/* tslint:disable */
/* eslint-disable */
export enum KundesegmentEnum {
  Privat = 'Privat',
  Erhverv = 'Erhverv'
}
